"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_uyx35s7tw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Telephone.tsx";
  var hash = "d015a13922ef2aacaaab9a36845dc0edab75310b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Telephone.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d015a13922ef2aacaaab9a36845dc0edab75310b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_uyx35s7tw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_uyx35s7tw();
var Icon = (cov_uyx35s7tw().s[0]++, {
  name: 'telephone',
  svg: "<path d=\"M18.208 15.1486C17.1709 14.2468 16.1184 13.7005 15.094 14.601L14.4824 15.1452C14.0348 15.5403 13.2027 17.3862 9.98562 13.6235C6.76917 9.86553 8.68323 9.28041 9.13143 8.88875L9.74645 8.34382C10.7654 7.44128 10.3809 6.3051 9.64595 5.13554L9.20244 4.42713C8.46415 3.2603 7.66021 2.494 6.63853 3.39517L6.08648 3.88561C5.63494 4.22006 4.37274 5.30719 4.06657 7.37248C3.6981 9.85055 4.86047 12.6883 7.52354 15.8019C10.1833 18.9168 12.7874 20.4814 15.2541 20.4542C17.3042 20.4317 18.5423 19.3132 18.9295 18.9066L19.4836 18.4155C20.5026 17.515 19.8695 16.5981 18.8317 15.6942L18.208 15.1486Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;